import { createIconComponent } from '../../factory/create-icon-component';
export const MacaoIcon = createIconComponent(
  'MacaoIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10086_33575)">
      <path d="M23 5H1V20H23V5Z" fill="#496E2D" />
      <path
        d="M13.2755 12.187C13.0955 12.187 12.9246 12.2237 12.7658 12.2821C12.8528 12.0839 12.911 11.8634 12.911 11.628C12.911 10.6963 12.0001 9.99756 12.0001 9.99756C12.0001 9.99756 11.0891 10.6963 11.0891 11.628C11.0891 11.8634 11.1473 12.0839 11.2343 12.2821C11.0756 12.2237 10.9047 12.187 10.7246 12.187C9.81364 12.187 9.13043 13.1187 9.13043 13.1187C9.13043 13.1187 9.81368 14.0503 10.7246 14.0503C11.2587 14.0503 11.7142 13.7301 12 13.4652C12.2858 13.7302 12.7413 14.0503 13.2754 14.0503C14.1864 14.0503 14.8696 13.1187 14.8696 13.1187C14.8696 13.1187 14.1864 12.187 13.2755 12.187Z"
        fill="#F0F0F0"
      />
      <path
        d="M12.0001 7.93463L12.1883 8.52683H12.7972L12.3046 8.89298L12.4926 9.48518L12.0001 9.11912L11.5075 9.48518L11.6955 8.89298L11.2029 8.52683H11.8119L12.0001 7.93463Z"
        fill="#FFDA44"
      />
      <path
        d="M9.68452 8.97058L10.0465 9.3039L10.4684 9.05487L10.2703 9.50992L10.6322 9.84337L10.1478 9.79129L9.94969 10.2463L9.84836 9.75908L9.36389 9.70701L9.78576 9.45789L9.68452 8.97058Z"
        fill="#FFDA44"
      />
      <path
        d="M7.98956 10.704L8.46609 10.8077L8.70963 10.3762L8.76059 10.8717L9.23707 10.9753L8.79205 11.1779L8.84301 11.6733L8.517 11.3031L8.07198 11.5057L8.31557 11.0743L7.98956 10.704Z"
        fill="#FFDA44"
      />
      <path
        d="M14.3156 8.97058L13.9536 9.3039L13.5317 9.05487L13.7299 9.50992L13.3679 9.84337L13.8523 9.79129L14.0504 10.2463L14.1518 9.75908L14.6363 9.70701L14.2144 9.45789L14.3156 8.97058Z"
        fill="#FFDA44"
      />
      <path
        d="M16.0103 10.704L15.5339 10.8077L15.2903 10.3762L15.2393 10.8717L14.7629 10.9753L15.2079 11.1779L15.157 11.6733L15.4829 11.3031L15.928 11.5057L15.6844 11.0743L16.0103 10.704Z"
        fill="#FFDA44"
      />
      <path
        d="M11.9999 16.6591C12.7235 16.6591 13.3905 16.4122 13.9256 15.9967H10.0743C10.6093 16.4122 11.2763 16.6591 11.9999 16.6591Z"
        fill="#F0F0F0"
      />
      <path
        d="M9.07739 14.7026C9.17858 14.9394 9.30689 15.1614 9.45767 15.365H14.5428C14.6935 15.1614 14.8219 14.9395 14.9231 14.7026H9.07739Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_10086_33575">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
